import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { distinctUntilChanged } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class FormResponseChangesService {
    private readonly hasUserResponseChangedSubject = new BehaviorSubject<boolean>(false);

    readonly hasUserResponseChanged$: Observable<boolean> = this.hasUserResponseChangedSubject
        .asObservable()
        .pipe(distinctUntilChanged());

    markUserResponseChanged(): void {
        if (!this.hasUserResponseChangedSubject.value) {
            this.hasUserResponseChangedSubject.next(true);
        }
    }

    resetUserResponseChanged(): void {
        if (this.hasUserResponseChangedSubject.value) {
            this.hasUserResponseChangedSubject.next(false);
        }
    }

    getHasUserResponseChanged(): boolean {
        return this.hasUserResponseChangedSubject.value;
    }
}
